import { render, staticRenderFns } from "./AvatarVariants.vue?vue&type=template&id=1a865118"
import script from "./AvatarVariants.vue?vue&type=script&lang=js"
export * from "./AvatarVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports